export const API_ARANGO_DISCONNECTED = 'API_ARANGO_DISCONNECTED';
export const API_ARANGO_INCONSISTENT_DATA = 'API_ARANGO_INCONSISTENT_DATA';
export const API_ARANGO_QUERY_KILLED = 'API_ARANGO_QUERY_KILLED';
export const API_ARANGO_UNEXPECTED_DATA = 'API_ARANGO_UNEXPECTED_DATA';
export const API_AUTHENTICATION_CONFLICT = 'API_AUTHENTICATION_CONFLICT';
export const API_AUTHENTICATION_FAILURE = 'API_AUTHENTICATION_FAILURE';
export const API_CALLHOME_FAIL = 'API_CALLHOME_FAIL';
export const API_CORRUPTED_CONFIGURATION = 'API_CORRUPTED_CONFIGURATION';
export const API_CORRUPTED_SECRETS = 'API_CORRUPTED_SECRETS';
export const API_DISABLED_POSTDISCOVERY_ACTION =
  'API_DISABLED_POSTDISCOVERY_ACTION';
export const API_DISCOVERY_STATUS_FAIL = 'API_DISCOVERY_STATUS_FAIL';
export const API_DUPLICATE_DB_ENTRY = 'API_DUPLICATE_DB_ENTRY';
export const API_EMAIL_CONFLICT = 'API_EMAIL_CONFLICT';
export const API_EMPTY_CREDENTIALS = 'API_EMPTY_CREDENTIALS';
export const API_EXPIRED_ACCESS_TOKEN = 'API_EXPIRED_ACCESS_TOKEN';
export const API_EXPIRED_API_TOKEN = 'API_EXPIRED_API_TOKEN';
export const API_FAILED = 'API_FAILED';
export const API_FILE_DAMAGED = 'API_FILE_DAMAGED';
export const API_FILE_MISSING = 'API_FILE_MISSING';
export const API_FILE_NOT_DOWNLOADED = 'API_FILE_NOT_DOWNLOADED';
export const API_FILTER_RESOURCE_CONFLICT = 'API_FILTER_RESOURCE_CONFLICT';
export const API_FILTER_TOO_STRICT = 'API_FILTER_TOO_STRICT';
export const API_FORBIDDEN_ACTION = 'API_FORBIDDEN_ACTION';
export const API_GEN_NIMPEE_CERT_FAIL = 'API_GEN_NIMPEE_CERT_FAIL';
export const API_GRAPH_INVALID_PATH = 'API_GRAPH_INVALID_PATH';
export const API_GRAPH_LOAD_FAILED = 'API_GRAPH_LOAD_FAILED';
export const API_GRAPH_PARTIAL_PATH_MAX_ONCE =
  'API_GRAPH_PARTIAL_PATH_MAX_ONCE';
export const API_GRAPH_PROTOCOLS_NOT_UNIQUE = 'API_GRAPH_PROTOCOLS_NOT_UNIQUE';
export const API_INACTIVE_ACCOUNT = 'API_INACTIVE_ACCOUNT';
export const API_INSUFFICIENT_LICENSE = 'API_INSUFFICIENT_LICENSE';
export const API_INSUFFICIENT_RIGHTS = 'API_INSUFFICIENT_RIGHTS';
export const API_INVALID_ACCESS_TOKEN = 'API_INVALID_ACCESS_TOKEN';
export const API_INVALID_API_TOKEN = 'API_INVALID_API_TOKEN';
export const API_INVALID_CERTIFICATE = 'API_INVALID_CERTIFICATE';
export const API_INVALID_COLUMN = 'API_INVALID_COLUMN';
export const API_INVALID_CREDENTIALS = 'API_INVALID_CREDENTIALS';
export const API_INVALID_ADMIN_PASSWORD = 'API_INVALID_ADMIN_PASSWORD';
export const API_INVALID_CSV_REQUEST = 'API_INVALID_CSV_REQUEST';
export const API_INVALID_DESTINATION = 'API_INVALID_DESTINATION';
export const API_INVALID_DEVICE = 'API_INVALID_DEVICE';
export const API_INVALID_DISCOVERY_STATUS = 'API_INVALID_DISCOVERY_STATUS';
export const API_INVALID_IP = 'API_INVALID_IP';
export const API_INVALID_LDAP_DOMAIN = 'API_INVALID_LDAP_DOMAIN';
export const API_INVALID_REFRESH_TOKEN = 'API_INVALID_REFRESH_TOKEN';
export const API_INVALID_RESOURCE = 'API_INVALID_RESOURCE';
export const API_INVALID_SESSION = 'API_INVALID_SESSION';
export const API_INVALID_SN = 'API_INVALID_SN';
export const API_JOB_CONFLICT = 'API_JOB_CONFLICT';
export const API_JOB_NOT_CANCELLABLE = 'API_JOB_NOT_CANCELLABLE';
export const API_JOB_NOT_STOPPABLE = 'API_JOB_NOT_STOPPABLE';
export const API_JOB_NOT_FORCE_STOPPABLE = 'API_JOB_NOT_FORCE_STOPPABLE';
export const API_JUMPHOST_FAILED = 'API_JUMPHOST_FAILED';
export const API_JUMPHOST_FORBIDDEN_SUBNET = 'API_JUMPHOST_FORBIDDEN_SUBNET';
export const API_JUMPHOST_RESOURCE_CONFLICT = 'API_JUMPHOST_RESOURCE_CONFLICT';
export const API_LDAP_ACCOUNT_DISABLED = 'API_LDAP_ACCOUNT_DISABLED';
export const API_LDAP_ACCOUNT_EXPIRED = 'API_LDAP_ACCOUNT_EXPIRED';
export const API_LDAP_ACCOUNT_LOCKED_OUT = 'API_LDAP_ACCOUNT_LOCKED_OUT';
export const API_LDAP_CONSTRAINT_VIOLATION = 'API_LDAP_CONSTRAINT_VIOLATION';
export const API_LDAP_INVALID_CREDENTIALS = 'API_LDAP_INVALID_CREDENTIALS';
export const API_LDAP_INVALID_GROUP = 'API_LDAP_INVALID_GROUP';
export const API_LDAP_INVALID_LOGON_HOURS = 'API_LDAP_INVALID_LOGON_HOURS';
export const API_LDAP_INVALID_SEARCH_BASE = 'API_LDAP_INVALID_SEARCH_BASE';
export const API_LDAP_INVALID_WORKSTATION = 'API_LDAP_INVALID_WORKSTATION';
export const API_LDAP_NOT_REACHABLE = 'API_LDAP_NOT_REACHABLE';
export const API_LDAP_PASSWORD_EXPIRED = 'API_LDAP_PASSWORD_EXPIRED';
export const API_LDAP_PASSWORD_MUST_CHANGE = 'API_LDAP_PASSWORD_MUST_CHANGE';
export const API_LDAP_SEARCH_FAILED = 'API_LDAP_SEARCH_FAILED';
export const API_LICENSE_EXPIRED = 'API_LICENSE_EXPIRED';
export const API_LICENSE_INVALID = 'API_LICENSE_INVALID';
export const API_LICENSE_NOT_FOUND = 'API_LICENSE_NOT_FOUND';
export const AIM_LICENSE_FEATURE_UNAVAILABLE =
  'AIM_LICENSE_FEATURE_UNAVAILABLE';
export const API_MAINTENANCE_IN_PROGRESS = 'API_MAINTENANCE_IN_PROGRESS';
export const API_MALFORMED_BODY = 'API_MALFORMED_BODY';
export const API_MISSING_CREDENTIALS = 'API_MISSING_CREDENTIALS';
export const API_MISSING_GLIP_URL = 'API_MISSING_GLIP_URL';
export const API_MONGO_DISCONNECTED = 'API_MONGO_DISCONNECTED';
export const API_NIMPEE_CERT_RENAME_FAIL = 'API_NIMPEE_CERT_RENAME_FAIL';
export const API_NOTHING_TO_DO = 'API_NOTHING_TO_DO';
export const API_NOT_ENOUGH_DISK_SPACE = 'API_NOT_ENOUGH_DISK_SPACE';
export const API_NOT_ENOUGH_MEMORY = 'API_NOT_ENOUGH_MEMORY';
export const API_NOT_FOUND = 'API_NOT_FOUND';
export const API_NOT_IMPLEMENTED = 'API_NOT_IMPLEMENTED';
export const API_NO_DNS_SERVER_CONFIGURED = 'API_NO_DNS_SERVER_CONFIGURED';
export const API_NO_ROLES_ASSIGNED = 'API_NO_ROLES_ASSIGNED';
export const API_OS_GET_DISK_SPACE = 'API_OS_GET_DISK_SPACE';
export const API_OS_GET_HOSTNAME_FAIL = 'API_OS_GET_HOSTNAME_FAIL';
export const API_OS_GET_VERSION_FAIL = 'API_OS_GET_VERSION_FAIL';
export const API_OS_SYSTEM_STATUS_FAIL = 'API_OS_SYSTEM_STATUS_FAIL';
export const API_RABBIT_NOT_CONNECTED = 'API_RABBIT_NOT_CONNECTED';
export const API_REPORT_RESOURCE_CONFLICT = 'API_REPORT_RESOURCE_CONFLICT';
export const API_REPORT_GROUP_RESOURCE_CONFLICT =
  'API_REPORT_GROUP_RESOURCE_CONFLICT';
export const API_REQUEST_TIMEOUT = 'API_REQUEST_TIMEOUT';
export const API_RESOURCE_CANT_BE_REMOVED = 'API_RESOURCE_CANT_BE_REMOVED';
export const API_RESOURCE_CONFLICT = 'API_RESOURCE_CONFLICT';
export const API_ROLE_RESOURCE_CONFLICT = 'API_ROLE_RESOURCE_CONFLICT';
export const API_SHAPER_CHANGE_FAIL = 'API_SHAPER_CHANGE_FAIL';
export const API_SHAPER_GET_FAIL = 'API_SHAPER_GET_FAIL';
export const API_SITE_REPORT_DATA_FAIL = 'API_SITE_REPORT_DATA_FAIL';
export const API_SNAPSHOT_ALREADY_LOADED = 'API_SNAPSHOT_ALREADY_LOADED';
export const API_SNAPSHOT_CONFLICT = 'API_SNAPSHOT_CONFLICT';
export const API_SNAPSHOT_INVALID_FORMAT = 'API_SNAPSHOT_INVALID_FORMAT';
export const API_SNAPSHOT_INVALID_ID = 'API_SNAPSHOT_INVALID_ID';
export const API_SNAPSHOT_LOCKED = 'API_SNAPSHOT_LOCKED';
export const API_SNAPSHOT_MAX_LOADED_REACHED =
  'API_SNAPSHOT_MAX_LOADED_REACHED';
export const API_SNAPSHOT_MAX_LOCKED_REACHED =
  'API_SNAPSHOT_MAX_LOCKED_REACHED';
export const API_SNAPSHOT_NOT_CANCELED = 'API_SNAPSHOT_NOT_CANCELED';
export const API_SNAPSHOT_NOT_LOADED = 'API_SNAPSHOT_NOT_LOADED';
export const API_SNAPSHOT_TOPOLOGY_CALCULATION_ALREADY_RUN =
  'API_SNAPSHOT_TOPOLOGY_CALCULATION_ALREADY_RUN';
export const API_UNAVAILABLE_DEVICE = 'API_UNAVAILABLE_DEVICE';
export const API_UNSUPPORTED_CONTENT_TYPE = 'API_UNSUPPORTED_CONTENT_TYPE';
export const API_UNSUPPORTED_VERSION = 'API_UNSUPPORTED_VERSION';
export const API_UNSUPPORTED_WEBHOOK_TYPE = 'API_UNSUPPORTED_WEBHOOK_TYPE';
export const API_UPLOAD_FAILED = 'API_UPLOAD_FAILED';
export const API_UPLOAD_LIMIT_FILE_SIZE = 'API_UPLOAD_LIMIT_FILE_SIZE';
export const API_URL_NOT_REACHABLE = 'API_URL_NOT_REACHABLE';
export const API_USERNAME_CONFLICT = 'API_USERNAME_CONFLICT';
export const API_USER_CONFLICT = 'API_USER_CONFLICT';
export const API_VALIDATION_FAILED = 'API_VALIDATION_FAILED';
export const API_VENDOR_AUTH_FAILURE = 'API_VENDOR_AUTH_FAILURE';
export const API_VENDOR_CHECKPOINT_INVALID_DOMAIN =
  'API_VENDOR_CHECKPOINT_INVALID_DOMAIN';
export const API_VENDOR_CHECKPOINT_MISSING_DOMAIN =
  'API_VENDOR_CHECKPOINT_MISSING_DOMAIN';
export const API_VENDOR_CONNECTION_TEST_FAILED =
  'API_VENDOR_CONNECTION_TEST_FAILED';
export const API_VENDOR_INVALID_PROXY_URL = 'API_VENDOR_INVALID_PROXY_URL';
export const API_VENDOR_INVALID_PROXY_HOSTNAME =
  'API_VENDOR_INVALID_PROXY_HOSTNAME';
export const API_VENDOR_INVALID_PROXY_HOSTNAME_LOCALHOST =
  'API_VENDOR_INVALID_PROXY_HOSTNAME_LOCALHOST';
export const API_VENDOR_INVALID_PROXY_HOSTNAME_UNRESOLVABLE =
  'API_VENDOR_INVALID_PROXY_HOSTNAME_UNRESOLVABLE';
export const API_VENDOR_INVALID_PROXY_PROTOCOL =
  'API_VENDOR_INVALID_PROXY_PROTOCOL';
export const API_VENDOR_INVALID_URL = 'API_VENDOR_INVALID_URL';
export const API_VENDOR_INVALID_URL_HOSTNAME =
  'API_VENDOR_INVALID_URL_HOSTNAME';
export const API_VENDOR_INVALID_URL_HOSTNAME_LOCALHOST =
  'API_VENDOR_INVALID_URL_HOSTNAME_LOCALHOST';
export const API_VENDOR_INVALID_URL_HOSTNAME_UNRESOLVABLE =
  'API_VENDOR_INVALID_URL_HOSTNAME_UNRESOLVABLE';
export const API_VENDOR_INVALID_URL_PATH = 'API_VENDOR_INVALID_URL_PATH';
export const API_VENDOR_INVALID_URL_PROTOCOL =
  'API_VENDOR_INVALID_URL_PROTOCOL';
export const API_VENDOR_INVALID_PARAMETER = 'API_VENDOR_INVALID_PARAMETER';
export const API_VENDOR_DUPLICITY_IN_PARAMETER =
  'API_VENDOR_DUPLICITY_IN_PARAMETER';
export const API_VENDOR_TEST_LIMIT_EXCEEDED = 'API_VENDOR_TEST_LIMIT_EXCEEDED';
export const API_VENDOR_UNEXPECTED_RESPONSE = 'API_VENDOR_UNEXPECTED_RESPONSE';
export const API_VPN_CONNECT_FAIL = 'API_VPN_CONNECT_FAIL';
export const API_VPN_DISCONNECT_FAIL = 'API_VPN_DISCONNECT_FAIL';
export const API_VPN_STATUS_FAIL = 'API_VPN_STATUS_FAIL';

// Nodejs common system errors https://nodejs.org/api/errors.html#common-system-errors
export const API_E2BIG = 'API_E2BIG';
export const API_EACCES = 'API_EACCES';
export const API_EADDRINFO = 'API_EADDRINFO';
export const API_EADDRINUSE = 'API_EADDRINUSE';
export const API_EADDRNOTAVAIL = 'API_EADDRNOTAVAIL';
export const API_EAFNOSUPPORT = 'API_EAFNOSUPPORT';
export const API_EAGAIN = 'API_EAGAIN';
export const API_EAIFAMNOSUPPORT = 'API_EAIFAMNOSUPPORT';
export const API_EAISERVICE = 'API_EAISERVICE';
export const API_EAISOCKTYPE = 'API_EAISOCKTYPE';
export const API_EALREADY = 'API_EALREADY';
export const API_EBADE = 'API_EBADE';
export const API_EBADF = 'API_EBADF';
export const API_EBADFD = 'API_EBADFD';
export const API_EBADMSG = 'API_EBADMSG';
export const API_EBADR = 'API_EBADR';
export const API_EBADRQC = 'API_EBADRQC';
export const API_EBADSLT = 'API_EBADSLT';
export const API_EBUSY = 'API_EBUSY';
export const API_ECANCELED = 'API_ECANCELED';
export const API_ECHARSET = 'API_ECHARSET';
export const API_ECHILD = 'API_ECHILD';
export const API_ECHRNG = 'API_ECHRNG';
export const API_ECOMM = 'API_ECOMM';
export const API_ECONNABORTED = 'API_ECONNABORTED';
export const API_ECONNREFUSED = 'API_ECONNREFUSED';
export const API_ECONNRESET = 'API_ECONNRESET';
export const API_EDEADLK = 'API_EDEADLK';
export const API_EDEADLOCK = 'API_EDEADLOCK';
export const API_EDESTADDRREQ = 'API_EDESTADDRREQ';
export const API_EDOM = 'API_EDOM';
export const API_EDQUOT = 'API_EDQUOT';
export const API_EEXIST = 'API_EEXIST';
export const API_EFAULT = 'API_EFAULT';
export const API_EFBIG = 'API_EFBIG';
export const API_EHOSTDOWN = 'API_EHOSTDOWN';
export const API_EHOSTUNREACH = 'API_EHOSTUNREACH';
export const API_EHWPOISON = 'API_EHWPOISON';
export const API_EIDRM = 'API_EIDRM';
export const API_EILSEQ = 'API_EILSEQ';
export const API_EINPROGRESS = 'API_EINPROGRESS';
export const API_EINTR = 'API_EINTR';
export const API_EINVAL = 'API_EINVAL';
export const API_EIO = 'API_EIO';
export const API_EISCONN = 'API_EISCONN';
export const API_EISDIR = 'API_EISDIR';
export const API_EISNAM = 'API_EISNAM';
export const API_EKEYEXPIRED = 'API_EKEYEXPIRED';
export const API_EKEYREJECTED = 'API_EKEYREJECTED';
export const API_EKEYREVOKED = 'API_EKEYREVOKED';
export const API_EL2HLT = 'API_EL2HLT';
export const API_EL2NSYNC = 'API_EL2NSYNC';
export const API_EL3HLT = 'API_EL3HLT';
export const API_EL3RST = 'API_EL3RST';
export const API_ELIBACC = 'API_ELIBACC';
export const API_ELIBBAD = 'API_ELIBBAD';
export const API_ELIBEXEC = 'API_ELIBEXEC';
export const API_ELIBMAX = 'API_ELIBMAX';
export const API_ELIBSCN = 'API_ELIBSCN';
export const API_ELNRANGE = 'API_ELNRANGE';
export const API_ELOOP = 'API_ELOOP';
export const API_EMEDIUMTYPE = 'API_EMEDIUMTYPE';
export const API_EMFILE = 'API_EMFILE';
export const API_EMLINK = 'API_EMLINK';
export const API_EMSGSIZE = 'API_EMSGSIZE';
export const API_EMULTIHOP = 'API_EMULTIHOP';
export const API_ENAMETOOLONG = 'API_ENAMETOOLONG';
export const API_ENETDOWN = 'API_ENETDOWN';
export const API_ENETRESET = 'API_ENETRESET';
export const API_ENETUNREACH = 'API_ENETUNREACH';
export const API_ENFILE = 'API_ENFILE';
export const API_ENOANO = 'API_ENOANO';
export const API_ENOBUFS = 'API_ENOBUFS';
export const API_ENODATA = 'API_ENODATA';
export const API_ENODEV = 'API_ENODEV';
export const API_ENOENT = 'API_ENOENT';
export const API_ENOEXEC = 'API_ENOEXEC';
export const API_ENOKEY = 'API_ENOKEY';
export const API_ENOLCK = 'API_ENOLCK';
export const API_ENOLINK = 'API_ENOLINK';
export const API_ENOMEDIUM = 'API_ENOMEDIUM';
export const API_ENOMEM = 'API_ENOMEM';
export const API_ENOMSG = 'API_ENOMSG';
export const API_ENONET = 'API_ENONET';
export const API_ENOPKG = 'API_ENOPKG';
export const API_ENOPROTOOPT = 'API_ENOPROTOOPT';
export const API_ENOSPC = 'API_ENOSPC';
export const API_ENOSR = 'API_ENOSR';
export const API_ENOSTR = 'API_ENOSTR';
export const API_ENOSYS = 'API_ENOSYS';
export const API_ENOTBLK = 'API_ENOTBLK';
export const API_ENOTCONN = 'API_ENOTCONN';
export const API_ENOTDIR = 'API_ENOTDIR';
export const API_ENOTEMPTY = 'API_ENOTEMPTY';
export const API_ENOTFOUND = 'API_ENOTFOUND';
export const API_ENOTRECOVERABLE = 'API_ENOTRECOVERABLE';
export const API_ENOTSOCK = 'API_ENOTSOCK';
export const API_ENOTSUP = 'API_ENOTSUP';
export const API_ENOTTY = 'API_ENOTTY';
export const API_ENOTUNIQ = 'API_ENOTUNIQ';
export const API_ENXIO = 'API_ENXIO';
export const API_EOF = 'API_EOF';
export const API_EOPNOTSUPP = 'API_EOPNOTSUPP';
export const API_EOVERFLOW = 'API_EOVERFLOW';
export const API_EOWNERDEAD = 'API_EOWNERDEAD';
export const API_EPERM = 'API_EPERM';
export const API_EPFNOSUPPORT = 'API_EPFNOSUPPORT';
export const API_EPIPE = 'API_EPIPE';
export const API_EPROTO = 'API_EPROTO';
export const API_EPROTONOSUPPORT = 'API_EPROTONOSUPPORT';
export const API_EPROTOTYPE = 'API_EPROTOTYPE';
export const API_ERANGE = 'API_ERANGE';
export const API_EREMCHG = 'API_EREMCHG';
export const API_EREMOTE = 'API_EREMOTE';
export const API_EREMOTEIO = 'API_EREMOTEIO';
export const API_ERESTART = 'API_ERESTART';
export const API_ERFKILL = 'API_ERFKILL';
export const API_EROFS = 'API_EROFS';
export const API_ESHUTDOWN = 'API_ESHUTDOWN';
export const API_ESOCKTNOSUPPORT = 'API_ESOCKTNOSUPPORT';
export const API_ESPIPE = 'API_ESPIPE';
export const API_ESRCH = 'API_ESRCH';
export const API_ESTALE = 'API_ESTALE';
export const API_ESTRPIPE = 'API_ESTRPIPE';
export const API_ETIME = 'API_ETIME';
export const API_ETIMEDOUT = 'API_ETIMEDOUT';
export const API_ETOOMANYREFS = 'API_ETOOMANYREFS';
export const API_ETXTBSY = 'API_ETXTBSY';
export const API_EUCLEAN = 'API_EUCLEAN';
export const API_EUNATCH = 'API_EUNATCH';
export const API_EUSERS = 'API_EUSERS';
export const API_EWOULDBLOCK = 'API_EWOULDBLOCK';
export const API_EXDEV = 'API_EXDEV';
export const API_EXFULL = 'API_EXFULL';
export const API_DEVICE_ACTION_FORBIDDEN = 'API_DEVICE_ACTION_FORBIDDEN';
export const API_DEVICE_JSON_NOT_FOUND = 'API_DEVICE_JSON_NOT_FOUND';

// Nodejs X509 related errors https://nodejs.org/api/tls.html#x509-certificate-error-codes
export const API_X509_CERT_CHAIN_TOO_LONG = 'API_X509_CERT_CHAIN_TOO_LONG';
export const API_X509_CERT_HAS_EXPIRED = 'API_X509_CERT_HAS_EXPIRED';
export const API_X509_CERT_NOT_YET_VALID = 'API_X509_CERT_NOT_YET_VALID';
export const API_X509_CERT_REJECTED = 'API_X509_CERT_REJECTED';
export const API_X509_CERT_REVOKED = 'API_X509_CERT_REVOKED';
export const API_X509_CERT_SIGNATURE_FAILURE =
  'API_X509_CERT_SIGNATURE_FAILURE';
export const API_X509_CERT_UNTRUSTED = 'API_X509_CERT_UNTRUSTED';
export const API_X509_CRL_HAS_EXPIRED = 'API_X509_CRL_HAS_EXPIRED';
export const API_X509_CRL_NOT_YET_VALID = 'API_X509_CRL_NOT_YET_VALID';
export const API_X509_CRL_SIGNATURE_FAILURE = 'API_X509_CRL_SIGNATURE_FAILURE';
export const API_X509_DEPTH_ZERO_SELF_SIGNED_CERT =
  'API_X509_DEPTH_ZERO_SELF_SIGNED_CERT';
export const API_X509_ERROR_IN_CERT_NOT_AFTER_FIELD =
  'API_X509_ERROR_IN_CERT_NOT_AFTER_FIELD';
export const API_X509_ERROR_IN_CERT_NOT_BEFORE_FIELD =
  'API_X509_ERROR_IN_CERT_NOT_BEFORE_FIELD';
export const API_X509_ERROR_IN_CRL_LAST_UPDATE_FIELD =
  'API_X509_ERROR_IN_CRL_LAST_UPDATE_FIELD';
export const API_X509_ERROR_IN_CRL_NEXT_UPDATE_FIELD =
  'API_X509_ERROR_IN_CRL_NEXT_UPDATE_FIELD';
export const API_X509_HOSTNAME_MISMATCH = 'API_X509_HOSTNAME_MISMATCH';
export const API_X509_INVALID_CA = 'API_X509_INVALID_CA';
export const API_X509_INVALID_PURPOSE = 'API_X509_INVALID_PURPOSE';
export const API_X509_OUT_OF_MEM = 'API_X509_OUT_OF_MEM';
export const API_X509_PATH_LENGTH_EXCEEDED = 'API_X509_PATH_LENGTH_EXCEEDED';
export const API_X509_SELF_SIGNED_CERT_IN_CHAIN =
  'API_X509_SELF_SIGNED_CERT_IN_CHAIN';
export const API_X509_UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY =
  'API_X509_UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY';
export const API_X509_UNABLE_TO_DECRYPT_CERT_SIGNATURE =
  'API_X509_UNABLE_TO_DECRYPT_CERT_SIGNATURE';
export const API_X509_UNABLE_TO_DECRYPT_CRL_SIGNATURE =
  'API_X509_UNABLE_TO_DECRYPT_CRL_SIGNATURE';
export const API_X509_UNABLE_TO_GET_CRL = 'API_X509_UNABLE_TO_GET_CRL';
export const API_X509_UNABLE_TO_GET_ISSUER_CERT_LOCALLY =
  'API_X509_UNABLE_TO_GET_ISSUER_CERT_LOCALLY';
export const API_X509_UNABLE_TO_GET_ISSUER_CERT =
  'API_X509_UNABLE_TO_GET_ISSUER_CERT';
export const API_X509_UNABLE_TO_VERIFY_LEAF_SIGNATURE =
  'API_X509_UNABLE_TO_VERIFY_LEAF_SIGNATURE';

export const apiErrorCodes = {
  [API_ARANGO_DISCONNECTED]: 'ArangoDB Disconnected',
  [API_ARANGO_INCONSISTENT_DATA]: 'ArangoDB contains inconsistent data',
  [API_ARANGO_QUERY_KILLED]: 'ArangoDB Query Killed While Executing',
  [API_ARANGO_UNEXPECTED_DATA]: 'Unexpected Data',
  [API_AUTHENTICATION_CONFLICT]: 'Authentication Conflict',
  [API_AUTHENTICATION_FAILURE]: 'Authentication Failure',
  [API_CALLHOME_FAIL]: 'Failed to send parsing errors to the callhome server',
  [API_CORRUPTED_CONFIGURATION]: 'Corrupted Device Configuration Data',
  [API_CORRUPTED_SECRETS]: 'Corrupted Secrets',
  [API_DISABLED_POSTDISCOVERY_ACTION]: 'Disabled post-discovery action',
  [API_DISCOVERY_STATUS_FAIL]: "Can't get status for last discovery",
  [API_DUPLICATE_DB_ENTRY]: 'Entry already exists in the collection',
  [API_EMAIL_CONFLICT]: 'Email Conflict',
  [API_EMPTY_CREDENTIALS]: 'Empty Credentials',
  [API_EXPIRED_ACCESS_TOKEN]: 'Expired JWT Access Token',
  [API_EXPIRED_API_TOKEN]: 'Expired API Token',
  [API_FAILED]: 'Unexpected Failure',
  [API_FILE_DAMAGED]: 'Damaged File',
  [API_FILE_MISSING]: 'Missing File',
  [API_FILE_NOT_DOWNLOADED]: "File hasn't been downloaded yet",
  [API_FILTER_RESOURCE_CONFLICT]: 'Filter Resource Conflict',
  [API_FILTER_TOO_STRICT]: 'Filter is too strict',
  [API_FORBIDDEN_ACTION]: 'Forbidden Action',
  [API_GEN_NIMPEE_CERT_FAIL]: 'Generation of certificate failed',
  [API_GRAPH_INVALID_PATH]: 'Graph Invalid Path',
  [API_GRAPH_LOAD_FAILED]: 'Graph Load Failure',
  [API_GRAPH_PARTIAL_PATH_MAX_ONCE]:
    'Partial graph layout only supports unique paths',
  [API_GRAPH_PROTOCOLS_NOT_UNIQUE]: 'Graph protocols are not unique',
  [API_INACTIVE_ACCOUNT]: 'Inactive Account',
  [API_INSUFFICIENT_LICENSE]: 'Insufficient license',
  [API_INSUFFICIENT_RIGHTS]: 'Insufficient Rights',
  [API_INVALID_ACCESS_TOKEN]: 'Invalid JWT Access Token',
  [API_INVALID_API_TOKEN]: 'Invalid API Token',
  [API_INVALID_CERTIFICATE]:
    'Invalid certificate (Only Base64 encoded PEM is supported)',
  [API_INVALID_COLUMN]: 'Invalid Column',
  [API_INVALID_CREDENTIALS]: 'Invalid Credentials',
  [API_INVALID_ADMIN_PASSWORD]: 'Invalid Admin Password',
  [API_INVALID_CSV_REQUEST]: 'CSV data can only be exported to a file',
  [API_INVALID_DESTINATION]: 'Invalid Destination',
  [API_INVALID_DEVICE]: 'Invalid Device',
  [API_INVALID_DISCOVERY_STATUS]: 'Invalid Discovery Status',
  [API_INVALID_IP]: 'Invalid IP Address(es)',
  [API_INVALID_LDAP_DOMAIN]: 'Invalid LDAP Domain',
  [API_INVALID_REFRESH_TOKEN]: 'You are not logged in',
  [API_INVALID_RESOURCE]: 'Invalid Resource',
  [API_INVALID_SESSION]:
    'The session is no longer valid. Please sign in again.',
  [API_INVALID_SN]: 'Invalid Serial Number',
  [API_JOB_CONFLICT]: 'Job Conflict',
  [API_JOB_NOT_CANCELLABLE]: 'Job Not Cancellable',
  [API_JOB_NOT_STOPPABLE]: 'Job Not Stoppable',
  [API_JOB_NOT_FORCE_STOPPABLE]: 'Job Not Force Stoppable',
  [API_JUMPHOST_FAILED]: 'Jumphost Connection Failed',
  [API_JUMPHOST_FORBIDDEN_SUBNET]: 'Forbidden Subnet',
  [API_JUMPHOST_RESOURCE_CONFLICT]: 'Jumphost Resource Conflict',
  [API_LDAP_ACCOUNT_DISABLED]: 'Account Disabled',
  [API_LDAP_ACCOUNT_EXPIRED]: 'Account Expired',
  [API_LDAP_ACCOUNT_LOCKED_OUT]: 'User Account Locked',
  [API_LDAP_CONSTRAINT_VIOLATION]:
    'Exceeded password retry limit, account locked',
  [API_LDAP_INVALID_CREDENTIALS]: 'Invalid LDAP Credentials',
  [API_LDAP_INVALID_GROUP]: 'Invalid LDAP Group',
  [API_LDAP_INVALID_LOGON_HOURS]: 'Not permitted to login at this time',
  [API_LDAP_INVALID_SEARCH_BASE]: 'Invalid Search Base',
  [API_LDAP_INVALID_WORKSTATION]: 'Not permitted to login at this workstation',
  [API_LDAP_NOT_REACHABLE]: 'LDAP as provided is not reachable',
  [API_LDAP_PASSWORD_EXPIRED]: 'Password Expired',
  [API_LDAP_PASSWORD_MUST_CHANGE]: 'User Must Reset Password',
  [API_LDAP_SEARCH_FAILED]: 'LDAP Search Failed',
  [API_LICENSE_EXPIRED]: 'License Expired',
  [API_LICENSE_INVALID]: 'Invalid License',
  [API_LICENSE_NOT_FOUND]: 'License Not Found',
  [AIM_LICENSE_FEATURE_UNAVAILABLE]: 'AIM feature unavailable',
  [API_MAINTENANCE_IN_PROGRESS]: 'Maintenance In Progress',
  [API_MALFORMED_BODY]: 'Malformed JSON',
  [API_MISSING_CREDENTIALS]: 'Missing credentials',
  [API_MISSING_GLIP_URL]:
    'Missing support channel url in settings, contact support',
  [API_MONGO_DISCONNECTED]: 'Disconnected MongoDB',
  [API_NIMPEE_CERT_RENAME_FAIL]:
    "Can't move uploaded certificate to specified path",
  [API_NOTHING_TO_DO]: 'Nothing To Do',
  [API_NOT_ENOUGH_DISK_SPACE]: 'Not Enough Disk Space',
  [API_NOT_ENOUGH_MEMORY]: 'Not Enough System Memory',
  [API_NOT_FOUND]: 'Requested Resource Not Found',
  [API_NOT_IMPLEMENTED]: 'Requested Resource Not Implemented',
  [API_NO_DNS_SERVER_CONFIGURED]: 'No DNS server is configured',
  [API_NO_ROLES_ASSIGNED]: 'User has no roles assigned',
  [API_OS_GET_DISK_SPACE]: "Can't get disk space of IP Fabric",
  [API_OS_GET_HOSTNAME_FAIL]: "Can't get system hostname",
  [API_OS_GET_VERSION_FAIL]: "Can't get current version of IP Fabric",
  [API_OS_SYSTEM_STATUS_FAIL]: "Can't get status about system",
  [API_RABBIT_NOT_CONNECTED]: 'Rabbit Not Connected',
  [API_REPORT_RESOURCE_CONFLICT]: 'Report Resource Conflict',
  [API_REPORT_GROUP_RESOURCE_CONFLICT]: 'Report Group Resource Conflict',
  [API_REQUEST_TIMEOUT]: 'Request Timeout',
  [API_RESOURCE_CANT_BE_REMOVED]: "Resource Can't Be Removed",
  [API_RESOURCE_CONFLICT]: 'Resource Conflict',
  [API_ROLE_RESOURCE_CONFLICT]: 'Role Resource Conflict',
  [API_SHAPER_CHANGE_FAIL]: 'Changing shaper failed',
  [API_SHAPER_GET_FAIL]: 'Unable to get traffic shaper settings',
  [API_SITE_REPORT_DATA_FAIL]: "Can't get site report data",
  [API_SNAPSHOT_ALREADY_LOADED]: 'Snapshot Already Loaded',
  [API_SNAPSHOT_CONFLICT]: 'Snapshot Conflict',
  [API_SNAPSHOT_INVALID_FORMAT]: 'Invalid Snapshot Format',
  [API_SNAPSHOT_INVALID_ID]: 'Invalid Snapshot ID',
  [API_SNAPSHOT_LOCKED]: 'Operation Not Permitted - Locked Snapshot',
  [API_SNAPSHOT_MAX_LOADED_REACHED]:
    'Reached Maximum Number of Loaded Snapshots',
  [API_SNAPSHOT_MAX_LOCKED_REACHED]:
    'Reached Maximum Number of Locked Snapshots',
  [API_SNAPSHOT_NOT_CANCELED]: 'Snapshot Is Not Canceled',
  [API_SNAPSHOT_NOT_LOADED]: 'Unloaded Snapshot',
  [API_SNAPSHOT_TOPOLOGY_CALCULATION_ALREADY_RUN]:
    'Topology Calculation Already Run For This Snapshot',
  [API_UNAVAILABLE_DEVICE]: 'Device no longer available',
  [API_UNSUPPORTED_CONTENT_TYPE]: 'Unsupported content type',
  [API_UNSUPPORTED_VERSION]: 'Unsupported version',
  [API_UNSUPPORTED_WEBHOOK_TYPE]: 'Unsupported webhook type',
  [API_UPLOAD_FAILED]: 'Upload Failed',
  [API_UPLOAD_LIMIT_FILE_SIZE]: 'Upload Failed: File is too big',
  [API_URL_NOT_REACHABLE]: 'Provided URL is not reachable',
  [API_USERNAME_CONFLICT]: 'Username Conflict',
  [API_USER_CONFLICT]: 'User Conflict',
  [API_VALIDATION_FAILED]: 'Invalid Input',
  [API_VENDOR_AUTH_FAILURE]: 'Invalid Credentials',
  [API_VENDOR_CHECKPOINT_INVALID_DOMAIN]: 'Invalid Check Point domain provided',
  [API_VENDOR_CHECKPOINT_MISSING_DOMAIN]:
    'At least one domain is required for a multi-domain Check Point server',
  [API_VENDOR_CONNECTION_TEST_FAILED]: 'Connection test failed',
  [API_VENDOR_INVALID_PROXY_URL]: 'Invalid proxy url',
  [API_VENDOR_INVALID_PROXY_HOSTNAME]: 'Invalid proxy hostname',
  [API_VENDOR_INVALID_PROXY_HOSTNAME_LOCALHOST]:
    'Localhost is not allowed in proxy hostname',
  [API_VENDOR_INVALID_PROXY_HOSTNAME_UNRESOLVABLE]:
    "Proxy hostname can't be resolved to an IP address",
  [API_VENDOR_INVALID_PROXY_PROTOCOL]: 'Invalid proxy protocol',
  [API_VENDOR_INVALID_URL]: 'Invalid url',
  [API_VENDOR_INVALID_URL_HOSTNAME]: 'Invalid url hostname',
  [API_VENDOR_INVALID_URL_HOSTNAME_LOCALHOST]:
    'Localhost is not allowed in hostname',
  [API_VENDOR_INVALID_URL_HOSTNAME_UNRESOLVABLE]:
    "Provided hostname can't be resolved to an IP address",
  [API_VENDOR_INVALID_URL_PATH]: 'Invalid url path',
  [API_VENDOR_INVALID_URL_PROTOCOL]: 'Invalid url protocol',
  [API_VENDOR_INVALID_PARAMETER]: 'Invalid "{{parameter}}" parameter provided',
  [API_VENDOR_DUPLICITY_IN_PARAMETER]:
    '"{{parameter}}" parameter contains duplicity',
  [API_VENDOR_TEST_LIMIT_EXCEEDED]: 'Test limit exceeded',
  [API_VENDOR_UNEXPECTED_RESPONSE]: 'Unexpected server response',
  [API_VPN_CONNECT_FAIL]: "Can't connect to VPN.",
  [API_VPN_DISCONNECT_FAIL]: "Can't disconnect VPN service",
  [API_VPN_STATUS_FAIL]: "Can't get status of VPN connection.",
  [API_DEVICE_ACTION_FORBIDDEN]: 'Action is not allowed for this device',
  [API_DEVICE_JSON_NOT_FOUND]: 'JSON file for device has not been found',

  // Nodejs common system errors https://nodejs.org/api/errors.html#common-system-errors
  [API_E2BIG]: 'Argument list too long',
  [API_EACCES]: 'Permission denied',
  [API_EADDRINFO]: 'Getaddrinfo error',
  [API_EADDRINUSE]: 'Address already in use',
  [API_EADDRNOTAVAIL]: 'Address not available',
  [API_EAFNOSUPPORT]: 'Address family not supported',
  [API_EAGAIN]: 'Resource temporarily unavailable',
  [API_EAIFAMNOSUPPORT]: 'Address family for hostname not supported',
  [API_EAISERVICE]: 'Servname not supported for ai_socktype',
  [API_EAISOCKTYPE]: 'ai_socktype not supported',
  [API_EALREADY]: 'Connection already in progress',
  [API_EBADE]: 'Invalid exchange',
  [API_EBADF]: 'Bad file descriptor',
  [API_EBADFD]: 'File descriptor in bad state',
  [API_EBADMSG]: 'Bad message',
  [API_EBADR]: 'Invalid request descriptor',
  [API_EBADRQC]: 'Invalid request code',
  [API_EBADSLT]: 'Invalid slot',
  [API_EBUSY]: 'Device or resource busy or locked',
  [API_ECANCELED]: 'Operation canceled',
  [API_ECHARSET]: 'Invalid Unicode character',
  [API_ECHILD]: 'No child processes',
  [API_ECHRNG]: 'Channel number out of range',
  [API_ECOMM]: 'Communication error on send',
  [API_ECONNABORTED]: 'Connection aborted',
  [API_ECONNREFUSED]: 'Connection refused',
  [API_ECONNRESET]: 'Connection reset by peer',
  [API_EDEADLK]: 'Resource deadlock avoided',
  [API_EDEADLOCK]: 'File locking deadlock error',
  [API_EDESTADDRREQ]: 'Destination address required',
  [API_EDOM]: 'Mathematics argument out of domain of function',
  [API_EDQUOT]: 'Disk quota exceeded',
  [API_EEXIST]: 'File exists',
  [API_EFAULT]: 'Bad address in system call argument',
  [API_EFBIG]: 'File too large',
  [API_EHOSTDOWN]: 'Host is down',
  [API_EHOSTUNREACH]: 'Host is unreachable',
  [API_EHWPOISON]: 'Memory page has hardware error',
  [API_EIDRM]: 'Identifier removed',
  [API_EILSEQ]: 'Invalid or incomplete multibyte or wide character',
  [API_EINPROGRESS]: 'Operation in progress',
  [API_EINTR]: 'Interrupted system call',
  [API_EINVAL]: 'Invalid argument',
  [API_EIO]: 'I/O error',
  [API_EISCONN]: 'Socket is already connected',
  [API_EISDIR]: 'Illegal operation on a directory',
  [API_EISNAM]: 'Is a named type file',
  [API_EKEYEXPIRED]: 'Key has expired',
  [API_EKEYREJECTED]: 'Key was rejected by service',
  [API_EKEYREVOKED]: 'Key has been revoked',
  [API_EL2HLT]: 'Level 2 halted',
  [API_EL2NSYNC]: 'Level 2 not synchronized',
  [API_EL3HLT]: 'Level 3 halted',
  [API_EL3RST]: 'Level 3 reset',
  [API_ELIBACC]: 'Cannot access a needed shared library',
  [API_ELIBBAD]: 'Accessing a corrupted shared library',
  [API_ELIBEXEC]: 'Cannot exec a shared library directly',
  [API_ELIBMAX]: 'Attempting to link in too many shared libraries',
  [API_ELIBSCN]: '.lib section in a.out corrupted',
  [API_ELNRANGE]: 'Link number out of range',
  [API_ELOOP]: 'Too many levels of symbolic links',
  [API_EMEDIUMTYPE]: 'Wrong medium type',
  [API_EMFILE]: 'Too many open files in system',
  [API_EMLINK]: 'Too many links',
  [API_EMSGSIZE]: 'Message too long',
  [API_EMULTIHOP]: 'Multihop attempted',
  [API_ENAMETOOLONG]: 'Filename too long',
  [API_ENETDOWN]: 'Network is down',
  [API_ENETRESET]: 'Connection aborted by network',
  [API_ENETUNREACH]: 'Network is unreachable',
  [API_ENFILE]: 'Too many open files in system',
  [API_ENOANO]: 'No anode',
  [API_ENOBUFS]: 'No buffer space available',
  [API_ENODATA]:
    'The named attribute does not exist, or the process has no access to this attribute',
  [API_ENODEV]: 'No such device',
  [API_ENOENT]: 'No such file or directory',
  [API_ENOEXEC]: 'Exec format error',
  [API_ENOKEY]: 'Required key not available',
  [API_ENOLCK]: 'No locks available',
  [API_ENOLINK]: 'Link has been severed',
  [API_ENOMEDIUM]: 'No medium found',
  [API_ENOMEM]: 'Not enough memory',
  [API_ENOMSG]: 'No message of the desired type',
  [API_ENONET]: 'Machine is not on the network',
  [API_ENOPKG]: 'Package not installed',
  [API_ENOPROTOOPT]: 'Protocol not available',
  [API_ENOSPC]: 'No space left on device',
  [API_ENOSR]: 'No STREAM resources',
  [API_ENOSTR]: 'Not a STREAM',
  [API_ENOSYS]: 'Function not implemented',
  [API_ENOTBLK]: 'Block device required',
  [API_ENOTCONN]: 'Socket is not connected',
  [API_ENOTDIR]: 'Not a directory',
  [API_ENOTEMPTY]: 'Directory not empty',
  [API_ENOTFOUND]: 'DNS lookup failed',
  [API_ENOTRECOVERABLE]: 'State not recoverable',
  [API_ENOTSOCK]: 'Socket operation on non-socket',
  [API_ENOTSUP]: 'Operation not supported on socket',
  [API_ENOTTY]: 'Inappropriate I/O control operation',
  [API_ENOTUNIQ]: 'Name not unique on network',
  [API_ENXIO]: 'No such device or address',
  [API_EOF]: 'End of file',
  [API_EOPNOTSUPP]: 'Operation not supported on socket',
  [API_EOVERFLOW]: 'Value too large to be stored in data type',
  [API_EOWNERDEAD]: 'Owner died',
  [API_EPERM]: 'Operation not permitted',
  [API_EPFNOSUPPORT]: 'Protocol family not supported',
  [API_EPIPE]: 'Broken pipe',
  [API_EPROTO]: 'Protocol error',
  [API_EPROTONOSUPPORT]: 'Protocol not supported',
  [API_EPROTOTYPE]: 'Protocol wrong type for socket',
  [API_ERANGE]: 'Result too large',
  [API_EREMCHG]: 'Remote address changed',
  [API_EREMOTE]: 'Object is remote',
  [API_EREMOTEIO]: 'Remote I/O error',
  [API_ERESTART]: 'Interrupted system call should be restarted',
  [API_ERFKILL]: 'Operation not possible due to RF-kill',
  [API_EROFS]: 'Read-only file system',
  [API_ESHUTDOWN]: 'Cannot send after transport endpoint shutdown',
  [API_ESOCKTNOSUPPORT]: 'Socket type not supported',
  [API_ESPIPE]: 'Invalid seek',
  [API_ESRCH]: 'No such process',
  [API_ESTALE]: 'Stale file handle',
  [API_ESTRPIPE]: 'Streams pipe error',
  [API_ETIME]: 'Timer expired',
  [API_ETIMEDOUT]: 'Operation timed out',
  [API_ETOOMANYREFS]: 'Too many references: cannot splice',
  [API_ETXTBSY]: 'Text file busy',
  [API_EUCLEAN]: 'Structure needs cleaning',
  [API_EUNATCH]: 'Protocol driver not attached',
  [API_EUSERS]: 'Too many users',
  [API_EWOULDBLOCK]: 'Operation would block',
  [API_EXDEV]: 'Improper link',
  [API_EXFULL]: 'Exchange full',

  // Nodejs X509 related errors https://nodejs.org/api/tls.html#x509-certificate-error-codes
  [API_X509_CERT_CHAIN_TOO_LONG]: 'Certificate chain too long',
  [API_X509_CERT_HAS_EXPIRED]: 'Certificate has expired',
  [API_X509_CERT_NOT_YET_VALID]: 'Certificate is not yet valid',
  [API_X509_CERT_REJECTED]: 'Certificate rejected',
  [API_X509_CERT_REVOKED]: 'Certificate revoked',
  [API_X509_CERT_SIGNATURE_FAILURE]: 'Certificate signature failure',
  [API_X509_CERT_UNTRUSTED]: 'Certificate not trusted',
  [API_X509_CRL_HAS_EXPIRED]: 'Certificate revocation list has expired',
  [API_X509_CRL_NOT_YET_VALID]: 'Certificate revocation list is not yet valid',
  [API_X509_CRL_SIGNATURE_FAILURE]:
    'Certificate revocation list signature failure',
  [API_X509_DEPTH_ZERO_SELF_SIGNED_CERT]: 'Self signed certificate',
  [API_X509_ERROR_IN_CERT_NOT_AFTER_FIELD]:
    "Format error in certificate's notAfter field",
  [API_X509_ERROR_IN_CERT_NOT_BEFORE_FIELD]:
    "Format error in certificate's notBefore field",
  [API_X509_ERROR_IN_CRL_LAST_UPDATE_FIELD]:
    "Format error in Certificate revocation list's lastUpdate field",
  [API_X509_ERROR_IN_CRL_NEXT_UPDATE_FIELD]:
    "Format error in Certificate revocation list's nextUpdate field",
  [API_X509_HOSTNAME_MISMATCH]: 'X509 hostname mismatch',
  [API_X509_INVALID_CA]: 'Invalid CA certificate',
  [API_X509_INVALID_PURPOSE]: 'Unsupported certificate purpose',
  [API_X509_OUT_OF_MEM]: 'Out of memory',
  [API_X509_PATH_LENGTH_EXCEEDED]: 'Path length constraint exceeded',
  [API_X509_SELF_SIGNED_CERT_IN_CHAIN]:
    'Self signed certificate in certificate chain',
  [API_X509_UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY]:
    'Unable to decode issuer public key',
  [API_X509_UNABLE_TO_DECRYPT_CERT_SIGNATURE]:
    "Unable to decrypt certificate's signature",
  [API_X509_UNABLE_TO_DECRYPT_CRL_SIGNATURE]:
    "Unable to decrypt certificate revocation list's signature",
  [API_X509_UNABLE_TO_GET_CRL]: 'Unable to get certificate revocation list',
  [API_X509_UNABLE_TO_GET_ISSUER_CERT_LOCALLY]:
    'Unable to get local issuer certificate',
  [API_X509_UNABLE_TO_GET_ISSUER_CERT]: 'Unable to get issuer certificate',
  [API_X509_UNABLE_TO_VERIFY_LEAF_SIGNATURE]:
    'Unable to verify the first certificate',
};

export type ApiErrorCode = keyof typeof apiErrorCodes;
